import { initShareBar } from "crosstalk-comments-livechat-sdk";
export function autoInitShareBars() {
    const shareDivs = document.querySelectorAll('div[data-crosstalk-share-bar]');
    const shareEmbeds = [];
    shareDivs.forEach(shareDiv => {
        const config = {
            wp: shareDiv.dataset.wp || "",
            url: shareDiv.dataset.url || "",
            theme: shareDiv.dataset.theme || "light",
            isMono: shareDiv.dataset.isMono === "true" ? true : false
        };
        const instance = initShareBar(shareDiv, config);
        if (instance)
            shareEmbeds.push(instance);
    });
    return shareEmbeds;
}
